<div class="custom-form main-form">
	<div [formGroup]="formGroup" *ngIf="formInitialized$ | async; else loading">
		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.LINK_NAME' | translate: locale.language }}</label>
			</div>
			<div class="setting-field">
				<dx-text-box as-validator formControlName="name"></dx-text-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
				<label class="form-label">{{ 'AL.EXPIRY_DATE' | translate: locale.language }}</label>
			</div>
			<div class="setting-field">
				<dx-date-box as-validator [displayFormat]="dateFormat"  formControlName="expiryDate"></dx-date-box>
			</div>
		</div>

		<div class="settings-container">
			<div class="setting-description">
			<label class="form-label">{{ 'AL.DELETE_LINK' | translate: locale.language }}</label>
		</div>
		<div class="setting-field">
			<button style="position: relative; top:-5px; scale:0.75; transform-origin: left;" (click)="deleteLink()" type="button" class="btn btn-danger">Delete link</button>
		</div>
		</div>
	</div>
	<ng-template #loading>
		Loading...
	</ng-template>
</div>

<delete-link-modal></delete-link-modal>
